import useFeatures from 'hooks/useFeatures';
import useAppUser from '../../../../hooks/useAppUser';
import useHasRouteAccess from '../../../../router/useHasRouteAccess';
import { Item } from './Header.types';
import { itemsByRole } from './headerItemsConstants';

const useHeaderItems = () => {
  const hasRouteAccess = useHasRouteAccess();
  const allowedFlags = useFeatures();
  const hasItemAccess = (item: Item) => hasRouteAccess(item.path);
  const { userType } = useAppUser();

  const navigationProps = { ...itemsByRole({ allowedFlags })[userType!] };
  navigationProps.navItems = navigationProps.navItems
    .filter(hasItemAccess)
    .filter(
      ({ allowedToRender }) =>
        !allowedToRender || allowedToRender(allowedFlags),
    );

  navigationProps.dropdownItems = navigationProps.dropdownItems
    .filter(hasItemAccess)
    .filter(
      ({ allowedToRender }) =>
        !allowedToRender || allowedToRender(allowedFlags),
    );
  navigationProps.dropdownSecondaryItems =
    navigationProps.dropdownSecondaryItems?.filter(hasItemAccess);
  return navigationProps;
};

export default useHeaderItems;
